import { render, staticRenderFns } from "./LogoMonoSvg.vue?vue&type=template&id=fd1bce74&"
import script from "./LogoMonoSvg.vue?vue&type=script&lang=js&"
export * from "./LogoMonoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports